import PropTypes from 'prop-types'
import React from 'react'
import Button from 'common/components/Button'
import Icon from 'common/components/Icon'
import Text from 'common/components/Text'

export const DiscussControls = ({
  newThread,
  toggleNewThread,
  Shortcuts,
  t
}) => (
  <>
    <Shortcuts />

    <Button active={newThread} onClick={toggleNewThread}>
      <Icon icon="plus" />
      <Text>{t('toolbar.discuss.newThread')}</Text>
    </Button>
  </>
)

DiscussControls.propTypes = {
  placenewThreadhread: PropTypes.bool,
  toggleNewThread: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default DiscussControls
